<template>
  <div>
    <v-alert :type="alertType" v-model="alertActive" dismissible outline>
      {{ alertMessage }}
    </v-alert>
    <v-flex xs12 sm6 offset-sm3>
      <v-card max-width="600px">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container class="primary" fill-height>
            <v-layout fill-height>
              <v-flex xs12 align-end flexbox>
                <span class="headline white--text">
                  {{ $t('edit_profile') }}
                </span>
              </v-flex>
            </v-layout>
          </v-container>
          <v-card-text>
            <v-layout xs12 row wrap>
              <v-flex xs12 sm6 class="px-2">
                <v-text-field
                  :label="$t('ic')"
                  v-model="user.ICO"
                  disabled
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 class="px-2 mt-3">
                <v-btn primary small @click="getAres">{{ $t('ares') }}</v-btn>
              </v-flex>
              <v-flex xs12 sm6 class="px-2">
                <v-text-field
                  :label="$t('name')"
                  v-model="user.Name"
                  required
                  disabled
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 class="px-2">
                <v-text-field
                  :label="$t('dic')"
                  v-model="user.DIC"
                  :rules="dicRules"
                  disabled
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 class="px-2">
                <v-text-field
                  :label="$t('fname')"
                  v-model="user.UserFirstName"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 class="px-2">
                <v-text-field
                  :label="$t('surname')"
                  v-model="user.UserLastName"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 class="px-2">
                <v-text-field
                  :label="$t('street')"
                  v-model="user.Street"
                  :rules="streetRules"
                  required
                  disabled
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 class="px-2">
                <v-text-field
                  :label="$t('house_number')"
                  v-model="user.DescNumber"
                  :rules="hounoRules"
                  required
                  disabled
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 class="px-2">
                <v-text-field
                  :label="$t('house_ref')"
                  v-model="user.RefNumber"
                  :rules="houcoRules"
                  required
                  disabled
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 class="px-2">
                <v-text-field
                  :label="$t('city')"
                  v-model="user.City"
                  :rules="cityRules"
                  required
                  disabled
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 class="px-2">
                <v-text-field
                  :label="$t('psc')"
                  v-model="user.ZipCode"
                  :rules="pscRules"
                  required
                  disabled
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 class="px-2">
                <v-text-field
                  :label="$t('phone')"
                  v-model="user.Phone"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn flat to="/ecrmregistration">{{ $t('back') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn :disabled="!valid" color="primary" @click="doChange">
              {{ $t('proceed') }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-flex>
  </div>
</template>
<script>
export default {
  data() {
    return {
      valid: false,
      alertActive: false,
      alertType: 'success',
      alertMessage: '',
      user: {
        ICO: '',
        DIC: '',
        Name: '',
        UserFirstName: '',
        UserLastName: '',
        Street: '',
        DescNumber: '',
        RefNumber: '',
        CountryName: '',
        City: '',
        ZipCode: '',
        Email: '',
        passwd: '',
        Phone: ''
      },
      nameRules: [
        v => !!v || this.$t('field_is_required'),
        v => !(v.length > 99) || this.$t('field_is_too_long')
      ],
      streetRules: [
        v => !!v || this.$t('field_is_required'),
        v => !(v.length > 99) || this.$t('field_is_too_long')
      ],
      hounoRules: [
        v => !!v || this.$t('field_is_required'),
        v => !(v.length > 10) || this.$t('field_is_too_long'),
        v => /\d/.test(v) || this.$t('only_digits')
      ],
      houcoRules: [v => !(v.length > 10) || this.$t('field_is_too_long')],
      cityRules: [
        v => !!v || this.$t('field_is_required'),
        v => !(v.length > 99) || this.$t('field_is_too_long')
      ],
      pscRules: [
        v => !!v || this.$t('field_is_required'),
        v => !(v.length > 6) || this.$t('field_is_too_long'),
        v => /\d/.test(v) || this.$t('only_digits')
      ],
      dicRules: []
    }
  },
  methods: {
    async getAres() {
      this.$root.$loader(true)
      try {
        let res = await this.axios.get('/api/ares/ico/' + this.user.ICO + '/')
        this.user.ICO = res.data.ic
        this.user.DIC = res.data.dic
        this.user.Name = res.data.name
        this.user.Street = res.data.street
        this.user.DescNumber = res.data.house_no
        this.user.RefNumber = res.data.house_co
        this.user.City = res.data.city
        this.user.ZipCode = res.data.psc
        this.user.Type = res.data.type || 'person'
        this.user.IsVatPayer =
          this.user.dph_reg || this.user.dic.lenght > 10 ? true : false
      } catch (error) {
        this.$root.$gerror(error.response.data)
      } finally {
        this.$root.$loader(false)
      }
    },
    doChange() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.user.IsVatPayer = this.user.DIC.lenght < 10 ? false : true
      this.changeProfile()
    },
    async changeProfile() {
      this.$root.$loader(true)

      try {
        let resp = await this.$http.post(
          this.$providerURL + '/Api/Partner/UpdatePartner',
          this.user
        )
        if (resp.status === 200) {
          this.showAlert(this.$t('profile_saved'), 'success')
        }
      } catch (error) {
        this.$root.$gerror(error.response.data)
      } finally {
        this.$root.$loader(false)
      }
    },
    initialize() {
      this.user = this.$auth.user()
    },
    showAlert(message, type) {
      this.alertMessage = message
      this.alertType = type
      this.alertActive = true
      setTimeout(() => (this.alertActive = false), 10000)
    }
  },
  created() {
    this.initialize()
  }
}
</script>
